import { defineStore } from 'pinia';
import state from './state.js';
import actions from './actions.js';

export const useAssociatedLeadsStore = defineStore('associatedLeadsStore', {
    state() {
        return state;
    },
    actions,
});
